var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full mb-2"},[_c(_vm.activeMethod,{tag:"component",attrs:{"is-primary":_vm.isPrimary,"provider":_vm.provider,"button-text":_vm.buttonText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }